import React, { useEffect, useState } from 'react';
import { CircularProgress } from './CircularProgress';
import { FastingProtocol } from '@/types/fasting';
import { FastingBadges } from './FastingBadges';
import { useFasting } from '@/contexts/FastingContext';
import { TimerDisplay } from './TimerDisplay';
import { RefeedingCard } from './RefeedingCard';
import { FlameGraphic } from './FlameGraphic';
import { TimerControls } from './TimerControls';

interface FastingTimerProps {
  selectedProtocol: FastingProtocol;
}

export const FastingTimer: React.FC<FastingTimerProps> = ({
  selectedProtocol,
}) => {
  // Directly use timeElapsed from the context.
  const { isActive, timeElapsed, isPaused } = useFasting();
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);

  const totalDuration = selectedProtocol.durationHours * 60 * 60;
  const progress = Math.min((timeElapsed / totalDuration) * 100, 100);
  const isFastComplete = timeElapsed >= totalDuration;

  // Update time remaining whenever elapsed time changes
  useEffect(() => {
    setTimeRemaining(Math.max(totalDuration - timeElapsed, 0));
    console.log(`[FastingTimer] Updating display: Elapsed=${timeElapsed}, Remaining=${Math.max(totalDuration - timeElapsed, 0)}, Active=${isActive}`);
  }, [timeElapsed, totalDuration, isActive]);

  // Log component mounting with active state for debugging
  useEffect(() => {
    console.log(`[FastingTimer] Component mounted, Active state: ${isActive}, Time elapsed: ${timeElapsed}`);
    setIsInitialized(true);
  }, []);

  return (
    <div className="flex flex-col items-center mt-4 space-y-6">
      <div className="relative">
        {isActive && <FlameGraphic />}
        <CircularProgress
          progress={progress}
          size={280}
          strokeWidth={18}
        />
        <TimerDisplay
          timeElapsed={timeElapsed} 
          timeRemaining={timeRemaining}
          isActive={isActive}
          totalDuration={totalDuration}
        />
      </div>
      {isActive && <FastingBadges />}
      <TimerControls />
      {isFastComplete && <RefeedingCard />}
    </div>
  );
};
